<div class="all-title-box page-hero transportation-hero">
  <div class="hero-overlay"></div>
  <div class="container text-center hero-content">
    <span class="eyebrow">ANYSPACE Mobility</span>
    <h1>Smart Transportation</h1>
    <p>Increase value with smart transportation</p>
  </div>
</div>

<main class="modern-page executive-summary">
  <section class="intro-card">
    <span class="section-kicker">Transportation Strategy</span>
    <h1>Value Creation through Smart Transportation and Smart Shipping Solutions</h1>
    <p>Smart transportation, encompassing advanced technologies like IoT, AI, and data analytics, offers transformative solutions for businesses focused on shipping, logistics, and urban mobility. Through enhanced efficiency, reduced costs, and sustainable practices, smart transportation provides significant value across key strategic areas, while smart shipping solutions expand these benefits specifically within the logistics sector.</p>
  </section>

  <section class="strategy-section">
    <div class="section-heading">
      <span></span>
      <h2>Product Offering: Smart Shipping Solutions</h2>
      <span></span>
    </div>
    <article class="feature-card full-width">
      <div class="card-icon">🚚</div>
      <ul class="check-list">
        <li><strong>Smart Shipping Vehicles</strong> - Equipped with advanced IoT sensors, AI-powered navigation, and autonomous driving capabilities, our fleet of smart shipping vehicles can operate continuously, reducing downtime and minimizing human error. Autonomous trucks and delivery drones further enhance logistics efficiency.</li>
        <li><strong>Optimized Routing and Fleet Management</strong> - Our smart shipping systems use real-time data analytics to optimize delivery routes, reducing fuel consumption and shipping times.</li>
        <li><strong>Predictive Maintenance and Asset Monitoring</strong> - Predictive maintenance systems monitor vehicle health to alert operators of potential issues, reducing unplanned repairs and extending vehicle lifespans.</li>
        <li><strong>Sustainable Shipping Practices</strong> - Options for electric and hybrid vehicles reduce emissions and fuel dependency, supporting corporate sustainability goals.</li>
      </ul>
    </article>
  </section>

  <section class="insight-grid two-card">
    <article class="insight-card success wide-card">
      <div class="pill-icon">✓</div>
      <h2>Business Benefits of Smart Transportation and Shipping Solutions</h2>
      <ul class="check-list compact">
        <li><strong>Cost Efficiency and Operational Optimization</strong> - Real-time route optimization, autonomous vehicle integration, and predictive maintenance significantly reduce operational expenses.</li>
        <li><strong>Enhanced Customer Experience</strong> - Smart shipping solutions improve delivery accuracy, offering real-time tracking and transparent communication.</li>
        <li><strong>Data-Driven Insights for Strategic Decision-Making</strong> - Analytics provide insights for demand forecasting, fleet management, and urban planning.</li>
        <li><strong>Scalability and Adaptability for Business Growth</strong> - Our solutions scale with business needs, providing flexible options for varying shipping volumes.</li>
        <li><strong>Sustainability and Corporate Responsibility</strong> - Our solutions support corporate environmental goals, reducing emissions and incorporating EV options.</li>
      </ul>
    </article>

    <article class="insight-card conclusion-card">
      <div class="pill-icon">→</div>
      <h2>Integration</h2>
      <p>Smart shipping and transportation solutions integrate seamlessly with smart city initiatives, enabling partnerships that drive innovation, improve urban livability, and support sustainable growth.</p>
      <h2>Conclusion</h2>
      <p>Our smart shipping and transportation offerings deliver value through increased efficiency, sustainability, and improved customer experiences. With autonomous and data-driven logistics solutions, we empower businesses to lead in a competitive market, achieve growth objectives, and contribute to future-ready urban environments.</p>
    </article>
  </section>
  <section class="contact-strip">
    <span class="section-kicker">Next Step</span>
    <h2>Contact us for transportation information</h2>
    <p>Share your transportation or smart shipping interest and we will create a tracked inquiry for follow-up.</p>
    <a routerLink="/contact" [queryParams]="{ source: 'transportation', type: 'transportation' }" class="modern-cta">Contact for More Information</a>
  </section>

</main>
